<template>
	<router-view />
	<nut-tabbar v-model:visible="activeTabIndex" bottom>
		<nut-tabbar-item
			to="/"
			tab-title="首页"
			icon="home"
			font-class-name="iconfont"
			class-prefix="icon"
		>
		</nut-tabbar-item>
		<nut-tabbar-item
			to="/playlist"
			tab-title="媒体·播放"
			icon="play-circle"
			font-class-name="iconfont"
			class-prefix="icon"
		>
		</nut-tabbar-item>
		<nut-tabbar-item
			to="/user"
			tab-title="我的"
			icon="user1"
			font-class-name="iconfont"
			class-prefix="icon"
		>
		</nut-tabbar-item>
	</nut-tabbar>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
export default {
	name: 'Layout',
	setup() {
		const route = useRoute();
		const activeTabIndex = ref(0);
		const path = route.path;
		if (path.includes('/user')) {
			activeTabIndex.value = 2;
		}
		if (path.includes('/playlist')) {
			activeTabIndex.value = 1;
		}
		return {
			activeTabIndex,
		};
	},
};
</script>
